
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30676',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30676",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.55173",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8245",
  "hubspot-dlb": "static-2.1877",
  "HubStyleTokens": "static-2.11702",
  "I18n": "static-7.1652",
  "quartz": "static-1.7328",
  "quartz-config": "static-1.1106",
  "quartz-core": "static-1.6547",
  "react-dlb": "static-1.84",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.43",
  "reselect": "static-3.8",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.857",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55160",
  "feedback-utils": "static-1.55164",
  "forms-embed-utils-lib": "static-1.4685",
  "forms-utils-lib": "static-1.12981",
  "foundations-assets": "static-1.5096",
  "foundations-components": "static-1.8345",
  "foundations-theming": "static-1.4672",
  "hub-http": "static-1.6435",
  "hubspot-url-utils": "static-1.4282",
  "HubStyle": "static-2.12009",
  "icons": "static-2.671",
  "immutable": "static-2.83",
  "quick-fetch": "static-1.4071",
  "raven": "static-3.5925",
  "react": "static-7.190",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.75",
  "react-rhumb": "static-1-redact-emails-from-unexpected-route-pathname.6",
  "react-select-plus": "static-1.108",
  "react-utils": "static-2.5495",
  "react-virtualized": "static-2.103",
  "redux": "static-4.16",
  "StyleGuideUI": "static-3.492",
  "tinymce-plugins": "static-1.58064",
  "transmute": "static-2.85",
  "ui-images": "static-2.1219",
  "UIComponents": "static-3.8648",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9849",
  "styled-components": "static-2.94",
  "bend-plugin-trellis-migration": "static-1.3554",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3605",
  "quartz-webpack": "static-1.3552",
  "foundations-theming-specialty": "static-1.2388",
  "property-description-translator": "static-1.4060",
  "HeadJS": "static-2.782",
  "framer-motion": "static-1.75",
  "hs-test-utils-bend-plugin": "static-1.3356",
  "msw": "static-1.39",
  "testing-library": "static-1.155",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.226",
  "moment-timezone": "static-5.86",
  "jasmine": "static-4.4540",
  "jasmine-runner": "static-1.6670",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.860",
  "hubspotter-http": "static-1.4803",
  "mobile-manifest-mixins": "static-1.557",
  "module-federation": "static-1.29",
  "quartz-auth": "static-1.1003",
  "quartz-head": "static-1.993",
  "quartz-i18n": "static-1.1003",
  "quartz-routing": "static-1.758",
  "quartz-test": "static-1.1003",
  "quartz-tracking": "static-1.707",
  "trellis-components": "static-1.2413",
  "ui-fonts": "static-1.964",
  "usage-tracker-container": "static-1.7567",
  "usage-tracker-core": "static-1.7427",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.161",
  "conversations-skeleton-state": "static-1.7470",
  "reference-resolvers": "static-1.8403",
  "sanitize-text": "static-1.8370",
  "PatternValidationJS": "static-1.3118",
  "ReduxMessenger": "static-2.10586",
  "sanitize": "static-1.4697",
  "outpost": "static-1.4384",
  "rpc-client-utils": "static-1.4883",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4614",
  "floating-ui": "static-1.60",
  "hs-story-utils": "static-1.9646",
  "react-aria": "static-1.69",
  "react-create-root-preference": "static-1.52",
  "tanstack-table": "static-1.58",
  "trellis-assets": "static-1.2394",
  "bend-plugin-foundations-theming": "static-1.3155",
  "foundations-theming-base": "static-1.3657",
  "stylex": "static-1.37",
  "hs-locale-management": "static-1.234",
  "csstype": "static-1.50",
  "web-vitals": "static-1.9",
  "ai-components-ui-library": "static-1.9529",
  "atom": "static-1.5297",
  "codemirror": "static-5.98",
  "content-assistance-lib": "static-1.8098",
  "ContentUtils": "static-1.69001",
  "data-token-picker": "static-1.16781",
  "file-manager-components": "static-1.24298",
  "FileManagerCore": "static-1.39797",
  "FileManagerLib": "static-1.39938",
  "frontend-preferences-client": "static-1.8149",
  "hub-http-contrib": "static-1.3260",
  "interframe": "static-3.4976",
  "layout-dnd-components": "static-1.12855",
  "layout-dnd-utils": "static-1.11830",
  "property-translator": "static-1.5616",
  "react-codemirror": "static-1.10860",
  "react-colorpicker": "static-2.10428",
  "reference-resolvers-lite": "static-1.8319",
  "rich-text-lib": "static-1.20198",
  "tinymce-data": "static-1.41035",
  "tinymce-themes": "static-1.56920",
  "ui-addon-emoji-picker": "static-1.10107",
  "ui-addon-sales-email": "static-1.5433",
  "ui-brand-identity-lib": "static-1.16114",
  "bender-build-tools": "static-1.3347",
  "hub-http-shared-msw-handlers": "static-1.10483",
  "hubspotter-http-shared-msw-handlers": "static-1.10481",
  "usage-tracker-session-replay": "static-1.5263",
  "base-ui": "static-1.17",
  "react-day-picker": "static-1.6",
  "trellis-theming": "static-1.1176",
  "tanstack-virtual": "static-1.35",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.293",
  "chirp-fetch": "static-1.2109",
  "chatspot-core": "static-1.22488",
  "copilot-toolkit": "static-1.11696",
  "customer-data-objects-ui-components": "static-1.13251",
  "data-fetching-client": "static-1.9878",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.4977",
  "ui-addon-video-player": "static-1.8926",
  "ui-coaching-tips": "static-1.29166",
  "usage-tracker": "static-1.7577",
  "cms-field-types": "static-1.5035",
  "content-icons-ui": "static-1.2292",
  "integrations-lib": "static-1.16867",
  "customer-data-objects": "static-1.7905",
  "apollo-dlb": "static-3.86",
  "breeze-engine-lib": "static-1.1510",
  "apollo-link-hub-http": "static-2.4878",
  "apollo-stack-hubspot": "static-3.89",
  "graphql": "static-1.85",
  "immer": "static-1.94",
  "immerable": "static-1.4371",
  "ui-addon-iframeable": "static-1.9297",
  "video-components-external": "static-1.11992",
  "video-data-lib": "static-1.35650",
  "breeze-artifacts-sdk": "static-1.102",
  "audio-components": "static-1.6239",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29697",
  "FileManagerImages": "static-1.37449",
  "foundations-components-legacy": "static-1.1370",
  "html-to-image": "static-1.57",
  "react-immutable-proptypes": "static-2.8",
  "redux-toolkit": "static-1.7",
  "salesImages": "static-1.530",
  "ui-universal-auth": "static-1.9245",
  "urlinator": "static-1.4754",
  "video-components": "static-1.13994",
  "video-embed": "static-1.36484",
  "ts-schema": "static-1.4232",
  "ContentData": "static-1.69076",
  "layout-data-lib": "static-1.10155",
  "react-dnd-compat": "static-1.4837",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1765",
  "external-options-client-types": "static-1.4280",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7114",
  "hs-promise-utils": "static-1.5815",
  "inbound-db-properties-service-client": "static-1.3999",
  "NamespacedHubStyle": "static-2.9203",
  "growth-onboarding-confetti": "static-1.3281",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11367",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5704",
  "magpie-types": "static-1.5164",
  "simple-logging-lib": "static-1.3270",
  "avatar-components": "static-1.2718",
  "customer-data-ui-utilities": "static-1.10047",
  "growth-onboarding-feedback-components": "static-1.6803",
  "flux-actions": "static-1.356",
  "hubspot-apollo-client": "static-1.5098",
  "integrations-error-boundary-lib": "static-1.14282",
  "integrations-tracking-lib": "static-1.5829",
  "laboratory-lib": "static-3.7372",
  "native-integrations-shared-strings": "static-1.7998",
  "redux-observable": "static-1.11",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10482",
  "unified-auth": "static-1.759",
  "breeze-engine-chat-components": "static-1.488",
  "breeze-engine-core": "static-1.788",
  "ably": "static-2.2",
  "highlight.js": "static-1.82",
  "navigation-messaging": "static-1.7999",
  "content-media-composition-data-lib": "static-1.13031",
  "content-media-compositions": "static-2.17038",
  "idb-keyval": "static-1.47",
  "media-bridge-lib": "static-1.19300",
  "unified-auth-core-lib": "static-1.1041",
  "social-insights-client-types": "static-1.22646",
  "advanced-menus-core": "static-1.15480",
  "advanced-menus-lib": "static-1.12365",
  "ExportDialog": "static-6.10601",
  "ui-memberships-settings-lib": "static-1.34661",
  "conditional-properties-service-client": "static-1.3951",
  "crm-pipelines-api-client-types": "static-1.4289",
  "fdsr-migration-layer": "static-1.233",
  "framework-builder-read-service-client": "static-1.4161",
  "framework-data-schema-quick-fetch": "static-1.7019",
  "inbound-db-meta-service-client": "static-1.3718",
  "multi-currency-client-types": "static-1.3845",
  "persist-promise": "static-1.3922",
  "foundations-components-test-utils": "static-1.5828",
  "reactive-lib": "static-1.941",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.557",
  "universal-page-editor-lib": "static-1.3232",
  "adobe-sign-auth-lib": "static-1.302",
  "ads-unified-auth-lib": "static-1.874",
  "google-sheets-integration-lib": "static-1.881",
  "microsoft-drive-integration-lib": "static-1.1010",
  "surveymonkey-integration-lib": "static-1.323",
  "slack-ui-library": "static-1.10616",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3957",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15479",
  "simple-menus-lib": "static-1.16996",
  "crm-record-cards-service-types": "static-1.3735",
  "location-customization-utils-lib": "static-1.9938",
  "react-flip-move": "static-1.74"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30676",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.55173",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8245",
  "hubspot-dlb": "/hubspot-dlb/static-2.1877",
  "HubStyleTokens": "/HubStyleTokens/static-2.11702",
  "I18n": "/I18n/static-7.1652",
  "quartz": "/quartz/static-1.7328",
  "quartz-config": "/quartz-config/static-1.1106",
  "quartz-core": "/quartz-core/static-1.6547",
  "react-dlb": "/react-dlb/static-1.84",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reselect": "/reselect/static-3.8",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.857",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55160",
  "feedback-utils": "/feedback-utils/static-1.55164",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4685",
  "forms-utils-lib": "/forms-utils-lib/static-1.12981",
  "foundations-assets": "/foundations-assets/static-1.5096",
  "foundations-components": "/foundations-components/static-1.8345",
  "foundations-theming": "/foundations-theming/static-1.4672",
  "hub-http": "/hub-http/static-1.6435",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4282",
  "HubStyle": "/HubStyle/static-2.12009",
  "icons": "/icons/static-2.671",
  "immutable": "/immutable/static-2.83",
  "quick-fetch": "/quick-fetch/static-1.4071",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.190",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.75",
  "react-rhumb": "/react-rhumb/static-1-redact-emails-from-unexpected-route-pathname.6",
  "react-select-plus": "/react-select-plus/static-1.108",
  "react-utils": "/react-utils/static-2.5495",
  "react-virtualized": "/react-virtualized/static-2.103",
  "redux": "/redux/static-4.16",
  "StyleGuideUI": "/StyleGuideUI/static-3.492",
  "tinymce-plugins": "/tinymce-plugins/static-1.58064",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1219",
  "UIComponents": "/UIComponents/static-3.8648",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9849",
  "styled-components": "/styled-components/static-2.94",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3554",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3605",
  "quartz-webpack": "/quartz-webpack/static-1.3552",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2388",
  "property-description-translator": "/property-description-translator/static-1.4060",
  "HeadJS": "/HeadJS/static-2.782",
  "framer-motion": "/framer-motion/static-1.75",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3356",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.155",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.226",
  "moment-timezone": "/moment-timezone/static-5.86",
  "jasmine": "/jasmine/static-4.4540",
  "jasmine-runner": "/jasmine-runner/static-1.6670",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.860",
  "hubspotter-http": "/hubspotter-http/static-1.4803",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.557",
  "module-federation": "/module-federation/static-1.29",
  "quartz-auth": "/quartz-auth/static-1.1003",
  "quartz-head": "/quartz-head/static-1.993",
  "quartz-i18n": "/quartz-i18n/static-1.1003",
  "quartz-routing": "/quartz-routing/static-1.758",
  "quartz-test": "/quartz-test/static-1.1003",
  "quartz-tracking": "/quartz-tracking/static-1.707",
  "trellis-components": "/trellis-components/static-1.2413",
  "ui-fonts": "/ui-fonts/static-1.964",
  "usage-tracker-container": "/usage-tracker-container/static-1.7567",
  "usage-tracker-core": "/usage-tracker-core/static-1.7427",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.161",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7470",
  "reference-resolvers": "/reference-resolvers/static-1.8403",
  "sanitize-text": "/sanitize-text/static-1.8370",
  "PatternValidationJS": "/PatternValidationJS/static-1.3118",
  "ReduxMessenger": "/ReduxMessenger/static-2.10586",
  "sanitize": "/sanitize/static-1.4697",
  "outpost": "/outpost/static-1.4384",
  "rpc-client-utils": "/rpc-client-utils/static-1.4883",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4614",
  "floating-ui": "/floating-ui/static-1.60",
  "hs-story-utils": "/hs-story-utils/static-1.9646",
  "react-aria": "/react-aria/static-1.69",
  "react-create-root-preference": "/react-create-root-preference/static-1.52",
  "tanstack-table": "/tanstack-table/static-1.58",
  "trellis-assets": "/trellis-assets/static-1.2394",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3155",
  "foundations-theming-base": "/foundations-theming-base/static-1.3657",
  "stylex": "/stylex/static-1.37",
  "hs-locale-management": "/hs-locale-management/static-1.234",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.9",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9529",
  "atom": "/atom/static-1.5297",
  "codemirror": "/codemirror/static-5.98",
  "content-assistance-lib": "/content-assistance-lib/static-1.8098",
  "ContentUtils": "/ContentUtils/static-1.69001",
  "data-token-picker": "/data-token-picker/static-1.16781",
  "file-manager-components": "/file-manager-components/static-1.24298",
  "FileManagerCore": "/FileManagerCore/static-1.39797",
  "FileManagerLib": "/FileManagerLib/static-1.39938",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8149",
  "hub-http-contrib": "/hub-http-contrib/static-1.3260",
  "interframe": "/interframe/static-3.4976",
  "layout-dnd-components": "/layout-dnd-components/static-1.12855",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11830",
  "property-translator": "/property-translator/static-1.5616",
  "react-codemirror": "/react-codemirror/static-1.10860",
  "react-colorpicker": "/react-colorpicker/static-2.10428",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8319",
  "rich-text-lib": "/rich-text-lib/static-1.20198",
  "tinymce-data": "/tinymce-data/static-1.41035",
  "tinymce-themes": "/tinymce-themes/static-1.56920",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10107",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5433",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16114",
  "bender-build-tools": "/bender-build-tools/static-1.3347",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10483",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10481",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5263",
  "base-ui": "/base-ui/static-1.17",
  "react-day-picker": "/react-day-picker/static-1.6",
  "trellis-theming": "/trellis-theming/static-1.1176",
  "tanstack-virtual": "/tanstack-virtual/static-1.35",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.293",
  "chirp-fetch": "/chirp-fetch/static-1.2109",
  "chatspot-core": "/chatspot-core/static-1.22488",
  "copilot-toolkit": "/copilot-toolkit/static-1.11696",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13251",
  "data-fetching-client": "/data-fetching-client/static-1.9878",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.4977",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8926",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29166",
  "usage-tracker": "/usage-tracker/static-1.7577",
  "cms-field-types": "/cms-field-types/static-1.5035",
  "content-icons-ui": "/content-icons-ui/static-1.2292",
  "integrations-lib": "/integrations-lib/static-1.16867",
  "customer-data-objects": "/customer-data-objects/static-1.7905",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1510",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4878",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.89",
  "graphql": "/graphql/static-1.85",
  "immer": "/immer/static-1.94",
  "immerable": "/immerable/static-1.4371",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9297",
  "video-components-external": "/video-components-external/static-1.11992",
  "video-data-lib": "/video-data-lib/static-1.35650",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.102",
  "audio-components": "/audio-components/static-1.6239",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29697",
  "FileManagerImages": "/FileManagerImages/static-1.37449",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1370",
  "html-to-image": "/html-to-image/static-1.57",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "salesImages": "/salesImages/static-1.530",
  "ui-universal-auth": "/ui-universal-auth/static-1.9245",
  "urlinator": "/urlinator/static-1.4754",
  "video-components": "/video-components/static-1.13994",
  "video-embed": "/video-embed/static-1.36484",
  "ts-schema": "/ts-schema/static-1.4232",
  "ContentData": "/ContentData/static-1.69076",
  "layout-data-lib": "/layout-data-lib/static-1.10155",
  "react-dnd-compat": "/react-dnd-compat/static-1.4837",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1765",
  "external-options-client-types": "/external-options-client-types/static-1.4280",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7114",
  "hs-promise-utils": "/hs-promise-utils/static-1.5815",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3999",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9203",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3281",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11367",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5704",
  "magpie-types": "/magpie-types/static-1.5164",
  "simple-logging-lib": "/simple-logging-lib/static-1.3270",
  "avatar-components": "/avatar-components/static-1.2718",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10047",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6803",
  "flux-actions": "/flux-actions/static-1.356",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5098",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14282",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5829",
  "laboratory-lib": "/laboratory-lib/static-3.7372",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7998",
  "redux-observable": "/redux-observable/static-1.11",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10482",
  "unified-auth": "/unified-auth/static-1.759",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.488",
  "breeze-engine-core": "/breeze-engine-core/static-1.788",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.82",
  "navigation-messaging": "/navigation-messaging/static-1.7999",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13031",
  "content-media-compositions": "/content-media-compositions/static-2.17038",
  "idb-keyval": "/idb-keyval/static-1.47",
  "media-bridge-lib": "/media-bridge-lib/static-1.19300",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1041",
  "social-insights-client-types": "/social-insights-client-types/static-1.22646",
  "advanced-menus-core": "/advanced-menus-core/static-1.15480",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12365",
  "ExportDialog": "/ExportDialog/static-6.10601",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34661",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3951",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4289",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.233",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4161",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7019",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3845",
  "persist-promise": "/persist-promise/static-1.3922",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5828",
  "reactive-lib": "/reactive-lib/static-1.941",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.557",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3232",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.302",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.874",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.881",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.1010",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.323",
  "slack-ui-library": "/slack-ui-library/static-1.10616",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3957",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15479",
  "simple-menus-lib": "/simple-menus-lib/static-1.16996",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3735",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9938",
  "react-flip-move": "/react-flip-move/static-1.74"
}
};
